import TextInput from 'components/atoms/form/TextInput/TextInput'
import ToggleSwitch from 'components/atoms/form/ToggleSwitch/ToggleSwitch'
import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import RouteConst from 'constants/RouteConst'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import ExtraChargeService from '../../../../services/ExtraChargeService'
import {isObjectEmpty, updateObject, isCompletedHotelInfoHistory} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Card from '../../../molecules/Card/Card'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './ExtraCharges.scss'


class ExtraCharges extends Component {

    constructor(props) {
        super(props)

        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY);

        if (!hotelCode || isObjectEmpty(hotelInfo)) {
            this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }

        const isHotelDomestic = getSessionItem(SessionConst.IS_HOTEL_DOMESTIC)

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            hotelCurrency: getSessionItem(SessionConst.HOTEL_CURRENCY),
            isHotelDomestic: isHotelDomestic === FormConst.VALUE_NO ? false : true,
            extraCharges: [],
            errorMessage: undefined,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showErrorModal: false,
            initialValues: this.initialValues,
            showUpdateModal: false,
            hotelInfoCompletedHistory: hotelInfoCompletedHistory
        }
    }

    extraChargeTypes = {
        'ROLLAWAY': 'Not Started (Optional)',
        'CRIB': 'Not Started (Optional)',
        'EXTRA_PERSON': 'Not Started (Optional)'
    }

    extraChargeRoutes = {
        'ROLLAWAY': '/rollaway',
        'CRIB': '/cribs',
        'EXTRA_PERSON': '/extraPerson'
    }

    extraChargeLabels = {
        'ROLLAWAY': 'Rollaway Charges',
        'CRIB': 'Crib Charges',
        'EXTRA_PERSON': 'Extra Person Charges'
    }

    initialValues = {
        isRollaway: false, rollawayCount: 0, isRollawayCharged: false, rollawayAmount: 0.00,
        isCrib: false, cribCount: 0, isCribCharged: false, cribAmount: 0.00,
        isExtraPersonCharged: false, extraPersonAmount: 0.00,
    }

    validationSchema = Yup.object().shape({
        isRollaway: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
        rollawayCount: Yup.number().when('isRollaway', {
            is: (isRollaway) => isRollaway,
            then: Yup.number().required(FormConst.VALIDATION_ERROR_REQUIRED).min(0.01, '>0 required').test("int", "Must be an integer", val => {
                return val % 1 === 0
            })
        }),
        isRollawayCharged: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
        rollawayAmount: Yup.number().when(['isRollaway', 'isRollawayCharged'], {
            is: (isRollaway, isRollawayCharged) => isRollaway && isRollawayCharged,
            then: Yup.number().required(FormConst.VALIDATION_ERROR_REQUIRED).min(0.01, '>0 required')
        }),
        isCrib: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
        cribCount: Yup.number().when('isCrib', {
            is: (isCrib) => isCrib,
            then: Yup.number().required(FormConst.VALIDATION_ERROR_REQUIRED).min(0.01, '>0 required').test("int", "Must be an integer", val => {
                return val % 1 === 0
            })
        }),
        isCribCharged: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
        cribAmount: Yup.number().when(['isCrib', 'isCribCharged'], {
            is: (isCrib, isCribCharged) => isCrib && isCribCharged,
            then: Yup.number().required(FormConst.VALIDATION_ERROR_REQUIRED).min(0.01, '>0 required')
        }),
        isExtraPersonCharged: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
        extraPersonAmount: Yup.number().when(['isExtraPersonCharged'], {
            is: (isExtraPersonCharged) => isExtraPersonCharged,
            then: Yup.number().required(FormConst.VALIDATION_ERROR_REQUIRED).min(0.01, '>0 required')
        })
    })

    handleSubmit = (data) => {
        // let currentDate = getCurrentDate()
        // let startDate = getDateStringFromDate(currentDate)
        // let endDate = addYearsToDate(currentDate, 10)

        let extraCharges = []

        if (data.isRollaway) {
            extraCharges.push({
                "chargeType": "ROLLAWAY",
                "startDate": data.rollawayStartDate,
                "endDate": data.rollawayEndDate,
                "count": data.rollawayCount,
                "amount": data.isRollawayCharged ? data.rollawayAmount : 0.00,
            })
        }

        if (data.isCrib) {
            let defaultCribAmount = 0.00
            extraCharges.push({
                "chargeType": "CRIB",
                "startDate": data.cribStartDate,
                "endDate": data.cribEndDate,
                "count": data.cribCount,
                "amount": this.state.isHotelDomestic
                    ? (defaultCribAmount)
                    : (data.isCribCharged ? data.cribAmount : defaultCribAmount),
            })
        }

        if (data.isExtraPersonCharged) {
            extraCharges.push({
                "chargeType": "EXTRA_PERSON",
                "startDate": data.extraPersonStartDate,
                "endDate": data.extraPersonEndDate,
                "amount": data.isExtraPersonCharged ? data.extraPersonAmount : 0.00,
            })
        }

        this.props.onPut(this.state.hotelCode, extraCharges)
        this.setState({ showUpdateModal: true })
    }

    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            let extraCharges = this.state.hotelInfoCompletedHistory.newEntity?.hotelExtraCharge?.extraCharges;

            if (extraCharges) {
                let rollawayCharges = []
                let cribCharges = []
                let extraPersonCharges = []

                let initialValues = { ...this.state.initialValues }

                extraCharges.forEach(extraCharge => {
                    if (extraCharge.chargeType === 'ROLLAWAY') {
                        rollawayCharges.push(extraCharge)
                        initialValues = updateObject(initialValues, {
                            isRollaway: true, rollawayCount: extraCharge.count,
                            isRollawayCharged: extraCharge.amount > 0, rollawayAmount: extraCharge.amount,
                            rollawayStartDate: extraCharge.startDate,
                            rollawayEndDate: extraCharge.endDate
                        })
                    } else if (extraCharge.chargeType === 'CRIB') {
                        cribCharges.push(extraCharge)
                        initialValues = updateObject(initialValues, {
                            isCrib: true, cribCount: extraCharge.count,
                            isCribCharged: extraCharge.amount > 0, cribAmount: extraCharge.amount,
                            cribStartDate: extraCharge.startDate,
                            cribEndDate: extraCharge.endDate
                        })
                    } else {
                        extraPersonCharges.push(extraCharge)
                        initialValues = updateObject(initialValues, {
                            isExtraPersonCharged: extraCharge.amount > 0, extraPersonAmount: extraCharge.amount,
                            extraPersonStartDate: extraCharge.startDate,
                            extraPersonEndDate: extraCharge.endDate
                        })
                    }
                })

                this.setState({
                    extraCharges: extraCharges,
                    rollawayCharges: rollawayCharges,
                    cribCharges: cribCharges,
                    extraPersonCharges: extraPersonCharges,
                    errorMessage: undefined,
                    isLoading: false,
                    initialValues: initialValues
                })

            } else {
                this.setState({ extraCharges: undefined, isLoading: false })
            }
        } else {
            await ExtraChargeService.getExtraCharges({ hotelCode: this.state.hotelCode })
                .then(response => {
                    if (response?.extraCharges) {
                        let rollawayCharges = []
                        let cribCharges = []
                        let extraPersonCharges = []

                        let initialValues = { ...this.state.initialValues }

                        response.extraCharges.forEach(extraCharge => {
                            if (extraCharge.chargeType === 'ROLLAWAY') {
                                rollawayCharges.push(extraCharge)
                                initialValues = updateObject(initialValues, {
                                    isRollaway: true, rollawayCount: extraCharge.count,
                                    isRollawayCharged: extraCharge.amount > 0, rollawayAmount: extraCharge.amount,
                                    rollawayStartDate: extraCharge.startDate,
                                    rollawayEndDate: extraCharge.endDate
                                })
                            } else if (extraCharge.chargeType === 'CRIB') {
                                cribCharges.push(extraCharge)
                                initialValues = updateObject(initialValues, {
                                    isCrib: true, cribCount: extraCharge.count,
                                    isCribCharged: extraCharge.amount > 0, cribAmount: extraCharge.amount,
                                    cribStartDate: extraCharge.startDate,
                                    cribEndDate: extraCharge.endDate
                                })
                            } else {
                                extraPersonCharges.push(extraCharge)
                                initialValues = updateObject(initialValues, {
                                    isExtraPersonCharged: extraCharge.amount > 0, extraPersonAmount: extraCharge.amount,
                                    extraPersonStartDate: extraCharge.startDate,
                                    extraPersonEndDate: extraCharge.endDate
                                })
                            }
                        })

                        this.setState({
                            extraCharges: response.extraCharges,
                            rollawayCharges: rollawayCharges,
                            cribCharges: cribCharges,
                            extraPersonCharges: extraPersonCharges,
                            errorMessage: undefined,
                            isLoading: false,
                            initialValues: initialValues
                        })

                    } else {
                        this.setState({ extraCharges: undefined, isLoading: false })
                    }
                }).catch(error => {
                    this.setState({ errorMessage: 'There was an error while retrieving Extra Charges data', isLoading: false })
                    // Redirect to home page
                    // this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
                })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    showUpdateModal: false,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription,
                })
            } else {
                this.props.history.push(RouteConst.ROUTE_HOTEL_AMENITIES_PAGE)
            }
        }
    }

    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    resetFormData = (formikResetFormMethod) => {
        formikResetFormMethod()
        this.setState({
            showResetModal: false
        })
    }

    render() {
        return (
            <Formik
                initialValues={this.state.initialValues}
                validationSchema={this.validationSchema}
                enableReinitialize={true}
                onSubmit={(data, { setSubmitting }) => {
                    setSubmitting(true)
                    this.handleSubmit(data)
                    setSubmitting(false)
                }}
                onReset={this.handleReset} >
                {({ values, isSubmitting, isValid, handleChange, handleSubmit, setFieldValue, handleBlur, dirty, resetForm }) => (
                    <Form>

                        <div className='extra-charges-form-fields'>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><NavLink to='/'>Home</NavLink></li>
                                    <li className="breadcrumb-item active" aria-current="page">Extra Charges</li>
                                </ol>
                            </nav>

                            <p className='extra-charges-helper-text'>{FormConst.EXTRA_CHARGES_HEPLER_TEXT}</p>

                            {
                                !this.state.isLoading
                                && (
                                    <>
                                        {/* Rollaways card */}
                                        <Card
                                            id='rollaway-charges'
                                            header={this.extraChargeLabels['ROLLAWAY']}
                                            text={
                                                <Row className='justify-content-start'>
                                                    <Col xs={12} sm={12} md={6} lg={6} xl={6} className='align-items-center wide-item'>
                                                        <ToggleSwitch
                                                            id='isRollaway'
                                                            name='isRollaway'
                                                            label='Do you offer rollaway beds?'
                                                            checked={values.isRollaway}
                                                            value={values.isRollaway}
                                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                            onChange={handleChange} />
                                                    </Col>

                                                    {
                                                        values.isRollaway &&
                                                        (
                                                            <>
                                                                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                    <TextInput
                                                                        id='rollaway-count'
                                                                        name='rollawayCount'
                                                                        type='number'
                                                                        min='0'
                                                                        step='1'
                                                                        max='2500'
                                                                        placeholder='0'
                                                                        label='Inventory' />
                                                                </Col>
                                                                <Col xs={12} sm={12} md={6} lg={6} xl={6} className='wide-item'>
                                                                    <ToggleSwitch
                                                                        id='isRollawayCharged'
                                                                        name='isRollawayCharged'
                                                                        checked={values.isRollawayCharged}
                                                                        value={values.isRollawayCharged}
                                                                        label='Do you charge for them?'
                                                                        options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                                        onChange={handleChange} />
                                                                </Col>

                                                                {
                                                                    values.isRollaway && values.isRollawayCharged && (
                                                                        <Col xs={12} sm={12} md={6} lg={6} xl={6} className='wide-item'>
                                                                            <TextInput
                                                                                id='rollaway-amount'
                                                                                name='rollawayAmount'
                                                                                type='number'
                                                                                min='0.00'
                                                                                step='0.5'
                                                                                max='2500.00'
                                                                                placeholder='$0.00'
                                                                                label={`Cost (per Rollaway) in ${this.state.hotelCurrency}`}
                                                                                value={values.rollawayAmount} />
                                                                        </Col>
                                                                    )
                                                                }
                                                            </>
                                                        )
                                                    }
                                                </Row>
                                            } />
                                        {/* Cribs card */}
                                        <Card
                                            id='crib-charges'
                                            header={this.extraChargeLabels['CRIB']}
                                            text={
                                                <Row className='justify-content-start'>
                                                    <Col xs={12} sm={12} md={6} lg={6} xl={6} className='align-items-center wide-item'>
                                                        <ToggleSwitch
                                                            id='isCrib'
                                                            name='isCrib'
                                                            label='Do you offer cribs?'
                                                            checked={values.isCrib}
                                                            value={values.isCrib}
                                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                            onChange={handleChange} />
                                                    </Col>

                                                    {
                                                        values.isCrib &&
                                                        (
                                                            <>
                                                                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                    <TextInput
                                                                        id='crib-count'
                                                                        name='cribCount'
                                                                        type='number'
                                                                        min='0'
                                                                        step='1'
                                                                        max='2500'
                                                                        placeholder='0'
                                                                        label='Inventory' />
                                                                </Col>
                                                                {

                                                                    !this.state.isHotelDomestic
                                                                    && (
                                                                        <>
                                                                            <Col xs={12} sm={12} md={6} lg={6} xl={6} className='wide-item'>
                                                                                <ToggleSwitch
                                                                                    id='isCribCharged'
                                                                                    name='isCribCharged'
                                                                                    checked={values.isCribCharged}
                                                                                    value={values.isCribCharged}
                                                                                    label='Do you charge for them?'
                                                                                    options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                                                    onChange={handleChange} />
                                                                            </Col>
                                                                            {values.isCrib && values.isCribCharged && (
                                                                                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                                    <TextInput
                                                                                        id='crib-amount'
                                                                                        name='cribAmount'
                                                                                        type='number'
                                                                                        min='0.00'
                                                                                        step='0.5'
                                                                                        max='2500.00'
                                                                                        placeholder='$0.00'
                                                                                        label={`Cost (per Crib) in ${this.state.hotelCurrency}`}
                                                                                        value={values.cribAmount} />
                                                                                </Col>
                                                                            )}
                                                                        </>

                                                                    )
                                                                }
                                                            </>
                                                        )
                                                    }
                                                </Row>
                                            } />
                                        {/* Extra persons card */}
                                        <Card
                                            id='extra-person-charges'
                                            header={this.extraChargeLabels['EXTRA_PERSON']}
                                            text={
                                                <Row className='justify-content-start'>
                                                    <Col xs={12} sm={12} md={6} lg={6} xl={6} className='align-items-center wide-item'>
                                                        <ToggleSwitch
                                                            id='isExtraPersonCharged'
                                                            name='isExtraPersonCharged'
                                                            label='Do you charge for an extra person starting at the 3rd person?'
                                                            checked={values.isExtraPersonCharged}
                                                            value={values.isExtraPersonCharged}
                                                            options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                            onChange={handleChange} />
                                                    </Col>

                                                    {
                                                        values.isExtraPersonCharged &&
                                                        (

                                                            <Col xs={12} sm={12} md={6} lg={6} xl={6} className='wide-item'>
                                                                <TextInput
                                                                    id='extra-person-amount'
                                                                    name='extraPersonAmount'
                                                                    type='number'
                                                                    min='0.00'
                                                                    step='0.5'
                                                                    max='2500.00'
                                                                    placeholder='$0.00'
                                                                    label={`Cost (per Extra Person) in ${this.state.hotelCurrency}`}
                                                                    value={values.extraPersonAmount} />
                                                            </Col>
                                                        )
                                                    }
                                                </Row>
                                            } />
                                    </>
                                )
                            }
                            <FormFooter
                                form={SideNavEntryMapping.EXTRA_CHARGES}
                                isSubmit
                                submitName={FormConst.SAVE_BUTTON_TEXT}
                                resetName={FormConst.RESET_BUTTON_TEXT}
                                onReset={this.handleClearForm}
                                submitDisabled={isSubmitting} />
                            <FormModal
                                id='extra-charges-page-loading-modal'
                                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                hotelInfo={this.state.hotelInfo}
                                body={<h6>{this.state.loadingMessage}</h6>}
                                show={this.state.isLoading}
                                isLoadingIndicator />
                            <FormModal
                                id='extra-charges-page-update-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                body={<h5>{FormConst.MODAL_UPDATE_ACTION_TEXT}</h5>}
                                show={this.state.showUpdateModal}
                                isLoadingIndicator />
                            <FormModal
                                id='extra-charges-page-reset-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_RESET_ACTION_TITLE}
                                body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                                proceed={() => {
                                    this.resetFormData(resetForm)
                                }}
                                cancel={() => { this.setState({ showResetModal: false }) }}
                                show={this.state.showResetModal} />
                            <FormModal
                                id='extra-charges-page-error-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                body={<h5>{this.state.errorMessage}</h5>}
                                isError
                                cancel={() => { this.setState({ showErrorModal: false }) }}
                                show={this.state.showErrorModal} />
                        </div>
                    </Form>
                )}
            </Formik>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        extraChargesResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_EXTRA_CHARGES_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
        onPut: (hotelCode, extraCharges) => dispatch(asyncMethod(FormConst.FORM_EXTRA_CHARGES_NAME, actionTypes.ASYNC_ACTIONS.PUT, { hotelCode: hotelCode, formData: extraCharges }))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(ExtraCharges, SideNavEntryMapping.EXTRA_CHARGES))